import { IUnitTypeDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('unitTypes');

export const getUnitTypesAction = actionCreator.async<undefined, IUnitTypeDto[]>(
	constants.GET_UNIT_TYPES
);
